import { Typography, TypographyOwnProps, styled } from "@mui/material"

interface TitleProps extends TypographyOwnProps {
  noLineHeight?: boolean
  children: any
  sx?: any
}

export const PageTitle = ({
  children,
  noLineHeight,
  variant,
  align,
  sx,
  ...props
}: TitleProps) => {
  return (
    <Typography
      variant={variant || "h6"}
      align={align}
      sx={(theme) => ({
        color: theme.palette.primary.main,
        // lineHeight: noLineHeight ? null : 3,
        lineHeight: null,
        ...sx,
      })}
      {...props}
    >
      {children}
    </Typography>
  )
}

export const SubTitle = styled(PageTitle)(
  ({ theme }) => `
    font-size: 0.95rem;
  
    `
)
